import { render } from "./PenIcon.vue?vue&type=template&id=2c16d14b&scoped=true"
const script = {}

import "./PenIcon.vue?vue&type=style&index=0&id=2c16d14b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c16d14b"]])

export default __exports__